import { API } from "../axios/API";
import axios from "axios";

export const usuariosService = {
  getUser,
  login,
  validateToken
};

async function getUser(data) {
  try {
    const resp = await API.post("/usuarios", data);

    return resp;
  } catch (err) {
    console.log(err);
    return err;
  }
}

async function login(data) {
  try {
    const resp = await API.post("/usuarios/login", data);

    return resp;
  } catch (err) {
    console.log(err);
    return err;
  }
}

async function validateToken(data) {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_HEROKU_API}/usuarios/validate-token`, data);

    return resp?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
}